module.exports = __webpack_public_path__ + "static/media/GA_Feedback_2018.10.6.9a2e9b21.webp";